import React from 'react';
import { useSelector } from 'react-redux';

const SubCategories = ({}) => {
  const categories = useSelector((app) => app.news.categories);
  return (
    <div class='sidebar-widget widget_categories mb-50'>
      <div class='widget-header position-relative mb-20 pb-10'>
        <h5 class='widget-title mb-10'>Chuyên mục</h5>
        <div class='bt-1 border-color-1'></div>
      </div>
      <div class='post-block-list post-module-1 post-module-5'>
        <ul>
          {categories.map((item) => (
            <li class='cat-item cat-item-2' key={item.id}>
              <a
                href={`/${item.is_campaign == 1 ? 'chuyen-muc' : 'tin-tuc'}/${
                  item.slug
                }`}
              >
                {item.category_name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default SubCategories;
